<script lang="ts">
  import Button from '$components/reusable/Button.svelte';
  import { ContentType } from '$shared/lib';
  import ImageIcon from '$icons/files/ImageIcon.svelte';
  import { VITE_API_BASE_URL } from '$lib/env';
  import { toastError } from '$utils/toasts';
  import imageCompression, { type Options } from 'browser-image-compression';
  import LoaderIcon from '$icons/loaders/LoaderIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let isImageActive = false;
  export let processingImage = false;
  export let contentType: ContentType;
  let forumImage: FileList | null = null;
  //  Max size of an image attached to a post after compression
  // TODO confirm actual image size
  const maxSizeMB = 0.45;
  const compressImage = async () => {
    const options: Options = {
      maxSizeMB,
      maxWidthOrHeight: 1200,
      useWebWorker: true,
      maxIteration: 6,
    };
    try {
      let file: File;
      processingImage = true;
      // biome-ignore lint/style/noNonNullAssertion: TODO: Remove this non-null assertion
      if (forumImage![0].size / 1024 / 1024 <= maxSizeMB) {
        // biome-ignore lint/style/noNonNullAssertion: TODO: Remove this non-null assertion
        file = forumImage![0];
      } else {
        // biome-ignore lint/style/noNonNullAssertion: TODO: Remove this non-null assertion
        file = await imageCompression(forumImage![0], options);
      }
      if (file.size / 1024 / 1024 > maxSizeMB) {
        toastError(
          'Could not compress your image to the required size. Please try a smaller image.',
        );
        forumImage = null;
      } else {
        await handleForumImageUpload(file);
      }
    } catch (error) {
      processingImage = false;
      toastError(error);
    }
  };

  const handleForumImageUpload = async (file: File) => {
    const formData = new FormData();
    formData.append('forumImage', file);

    const xhr = new XMLHttpRequest();
    xhr.onload = async () => {
      if (xhr.status !== 200) {
        if (xhr.response === '"File too large"') {
          toastError('Maximum image size after compression is 3MB');
        } else {
          toastError(xhr.response);
        }
        forumImage = null;
      } else {
        // biome-ignore lint/style/noNonNullAssertion: TODO: Remove this non-null assertion
        const src = JSON.parse(xhr.response)!.url;
        dispatch('forum-image-posted', { src });
      }
      // stops the spinner
      processingImage = false;
    };
    xhr.onerror = () => {
      toastError('Failed to upload image');
    };
    xhr.open(
      'POST',
      `${VITE_API_BASE_URL}/api/forum/image?imageAttachmentContentType=${contentType}`,
      true,
    );
    xhr.send(formData);
  };
</script>

<Button secondary={isImageActive} tertiary={!isImageActive} class="relative" icon>
  <label for="rich-input-image" class="absolute inset-0 flex items-center justify-center">
    <input
      type="file"
      class="hidden"
      id="rich-input-image"
      accept="image/png, image/jpeg, image/jpg, image/webp"
      bind:files={forumImage}
      on:change={compressImage}
    />
    {#if processingImage}
      <LoaderIcon class="h-4 w-4" />
    {:else}
      <ImageIcon />
    {/if}
  </label>
</Button>
